<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-5">
        <NavBar variant="light" />
        <div class="padder">
          <h2>{{ title }}</h2>
          <slot name="form" />
        </div>
        <Footer />
      </div>
      <div class="col-lg-7 bg-img d-none d-lg-block" :style="`background-image: url(&quot;${bgImg}&quot;)`">
        <div class="d-flex h-100">
          <div class="justify-content-center align-self-center">
            <slot name="text" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="css">
  html, body {
    height: 100%;
  }
</style>

<style lang="scss" scoped>
  .container-fluid, .container-fluid .row {
    height: 100%;
    background-color: white;
  }

  .bg-img {
    background-position: center;
    background-repeat: no-repeat;
    background-attachment: scroll;
    background-size: cover;

    margin: 0;
    padding: 0;

    div.d-flex {
      display: block;
      height: 100%;
      margin: 0 auto;
      padding: 0 3em;
      color: #fff;


      h4 {
        width: 100%;
        text-align: center;
        vertical-align: middle;
        justify-content: center;
        margin: 0 auto 1em;
        position: relative;
        top: -4em;
      }

    }
  }

  h2 {
    margin: 1em 0;
    @media (max-width: 991px) {
      text-align: center;
    }
  }

  .padder {
    padding: 0 3em;
    margin: 0 auto 100px;
  }

</style>

<script>
  import Footer from "../../../components/navigation/Footer"
  import NavBar from "../../../components/navigation/Navbar"
  import BgImg from "../../../assets/img/twin-panel-background.jpg"

  export default {
    name: 'UserUtilsTwinPanel',
    components: {Footer, NavBar},
    props: {
      title: {type: String, required: true}
    },
    data() {
      return {
        bgImg: BgImg
      }
    }
  }
</script>
